import React, { useState } from "react";
import "./Nav.css";

import { Link, NavLink } from "react-router-dom";
import { motion } from "framer-motion";

import {
  useLang,
  useLogicalPath,
  useTranslations,
  LANGS,
  LANG_NAMES,
  langPath,
} from "../../i18n";

const Nav = ({ theme = "dark", showBrand = true }) => {
  const lang = useLang();
  const logical = useLogicalPath();
  const t = useTranslations();

  const [mode, setMode] = useState(() =>
    typeof document !== "undefined"
      ? document.documentElement.getAttribute("data-theme") || "dark"
      : "dark"
  );
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  const toggleMode = () => {
    const next = mode === "dark" ? "light" : "dark";
    const el = document.documentElement;
    el.classList.add("theme-transition");
    el.setAttribute("data-theme", next);
    try {
      localStorage.setItem("theme", next);
    } catch (e) {}
    window.setTimeout(() => el.classList.remove("theme-transition"), 500);
    setMode(next);
  };

  const links = [
    { to: langPath("", lang), label: t.nav.index, end: true },
    { to: langPath("/projects", lang), label: t.nav.work },
    { to: langPath("/about", lang), label: t.nav.about },
    { to: langPath("/contact", lang), label: t.nav.contact },
  ];

  return (
    <motion.nav
      className={`nav nav-${theme}${open ? " nav-open" : ""}`}
      initial={{ opacity: 0, y: -20 }}
      animate={{
        opacity: 1,
        y: 0,
        transition: { duration: 1, ease: [0.83, 0, 0.17, 1], delay: 0.5 },
      }}
    >
      <div className="nav-brand">
        {showBrand && (
          <Link to={langPath("", lang)} onClick={close}>
            <p>{t.siteName}</p>
          </Link>
        )}
      </div>

      <button
        type="button"
        className="nav-burger"
        onClick={() => setOpen((o) => !o)}
        aria-label="Menu"
        aria-expanded={open}
      >
        <span></span>
        <span></span>
      </button>

      <div className={`nav-right${open ? " is-open" : ""}`}>
        <div className="nav-links">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              onClick={close}
              className={({ isActive }) =>
                isActive ? "nav-link nav-link-active" : "nav-link"
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>
        <div className="nav-controls">
          <div className="nav-langs" aria-label="Language">
            {LANGS.map((l) => (
              <Link
                key={l}
                to={langPath(logical, l)}
                hrefLang={l}
                onClick={close}
                className={l === lang ? "nav-lang nav-lang-active" : "nav-lang"}
              >
                {LANG_NAMES[l]}
              </Link>
            ))}
          </div>
          <button
            type="button"
            className="nav-theme"
            onClick={toggleMode}
            aria-label="Toggle dark or light theme"
          >
            {mode === "dark" ? "☀" : "☾"}
          </button>
        </div>
      </div>
    </motion.nav>
  );
};

export default Nav;
